import { useContext } from "react";
import { FormContextMA } from "../form-context";
import {
  Section,
  H2,
  H3,
  P,
  DataField,
  Divider,
  TealSubSection,
} from "./common-components";
import { reasonOptions } from "../../patient/clinical-services/service-steps/clinical-assessment/data";
import { AllergicRhinitisDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";
import { classificationResultCalculation } from "../../patient/clinical-services/service-steps/treatment/data";
import {
  capitalizeFirstLetter,
  formatToYYYY_MMM_DD,
} from "../../../helpers/functions";
import { GetDropDownValue } from "./data";

export const PrescriptionsIssued = ({treatment, endService = null}) => {
  const { frequencyOfSymptoms = null, levelOfSeverity = null } =
    treatment || {};

  const getPrescriptionLabel = (p) =>
    `${p?.medicationName} ${
      p?.medicationGenCodeType !== "Sentence"
        ? `${p?.frequency} ${p?.form} ${p?.route} `
        : p?.sig
    }`.trim();

  const nonPharmacologicalPrescriptions = [];
  if (treatment?.nasalSalineRinsePrescriptions?.length) {
    nonPharmacologicalPrescriptions.push(
      `Nasal Saline Rinses - ${treatment.nasalSalineRinsePrescriptions[0].dosage}`
    );
  }
  if (treatment?.nasalSalineSprayPrescriptions?.length) {
    nonPharmacologicalPrescriptions.push(
      `Nasal Saline Sprays or Drops - ${treatment.nasalSalineSprayPrescriptions[0].dosage}`
    );
  }
  if (treatment?.nasalLubricantPrescriptions?.length) {
    nonPharmacologicalPrescriptions.push(
      `Nasal Lubricants & Gels - ${treatment.nasalLubricantPrescriptions[0].dosage}`
    );
  }

  const classification = classificationResultCalculation(
    frequencyOfSymptoms,
    levelOfSeverity
  );

  const firstLineTherapyPrescriptions = {
    label:
      classification === "Mild Intermittent"
        ? "First Line Therapy - Oral Antihistamine"
        : "First Line Therapy - Intranasal Corticosteroids",
    medication: treatment?.firstLineTherapyPrescriptions?.length
      ? [...treatment.firstLineTherapyPrescriptions]
      : [],
  };

  const stepUpTherapyPrescriptions = {
    label:
      classification === "Mild Intermittent"
        ? "Step Up Therapy - Intranasal Corticosteroids"
        : "Step Up Therapy - Intranasal Corticosteroids/ Antihistamines",
    medication: treatment?.stepUpTherapyPrescriptions?.length
      ? [...treatment.stepUpTherapyPrescriptions]
      : [],
  };
  const alternativeFirstLineTherapyPrescriptions = {
    label:
      "Alternative First Line Therapy - Intranasal Corticosteroids/ Antihistamines",
    medication: treatment?.alternativeFirstLineTherapyPrescriptions?.length
      ? [...treatment.alternativeFirstLineTherapyPrescriptions]
      : [],
  };

  const getPharmacologicalDrug = (therapy) => {
    let drug = therapy.medication[0];
    return (
      <div className="space-y-2">
        <DataField label={therapy.label} />
        {therapy.medication.length > 0 && (
          <TealSubSection isBlue={false} className="!bg-white">
            <DataField value={capitalizeFirstLetter(drug?.medicationName)} />
            <DataField
              label={"Reason"}
              value={capitalizeFirstLetter(GetDropDownValue(reasonOptions, drug?.reason))}
            />
            {drug?.sig && <DataField label={"SIG"} value={drug?.sig} />}
            <div className="grid grid-cols-4">
              <DataField label={"QTY"} value={drug?.dispenseQuantity} />
              <DataField label={"Refills"} value={drug?.refills ?? 0} />
              <DataField
                className={"col-span-2"}
                label={"Special Instructions"}
                value={capitalizeFirstLetter(drug?.comments)}
              />
            </div>
            <div className="grid grid-cols-2">
              <DataField
                label={"Start Date"}
                value={formatToYYYY_MMM_DD(drug?.startDate)}
              />
              <DataField
                label={"End Date"}
                value={formatToYYYY_MMM_DD(drug?.endDate)}
              />
            </div>
          </TealSubSection>
        )}
      </div>
    );
  };

  return (
    <Section className="space-y-[0.125in] !bg-gray-10 !border-gray-200">
      <H2>Prescriptions Issued</H2>
      <DataField label={"First Line- Prevention Tips / Avoid Allergens"} />
      <div className="space-y-[0.0833333in]">
        <H3>Non Pharmacological Treatment</H3>
        {treatment?.nasalSalineRinsePrescriptions?.length > 0 && (
          <TealSubSection isBlue={false} className="!bg-white">
            <DataField
              label={"Prescription(s) Issued"}
              value={`${nonPharmacologicalPrescriptions[0]}`}
            />
          </TealSubSection>
        )}
      </div>
      <div className="space-y-[0.0833333in]">
        <H3>Pharmacological Treatment</H3>
        {/* <DataField
          label="Prescriptions Issued"
          value={
            prescriptions.length
              ? prescriptions.map((p) => p.medicationName.trim()).join(", ")
              : "None"
          }
        /> */}
        {firstLineTherapyPrescriptions.medication?.length > 0 &&
          getPharmacologicalDrug(firstLineTherapyPrescriptions)}
        {stepUpTherapyPrescriptions.medication?.length > 0 &&
          getPharmacologicalDrug(stepUpTherapyPrescriptions)}
        {alternativeFirstLineTherapyPrescriptions.medication?.length > 0 &&
          getPharmacologicalDrug(alternativeFirstLineTherapyPrescriptions)}
      </div>
    </Section>
  );
};
